module.exports = __webpack_public_path__ + "img/AI智能路灯1.a37f0a2f.jpg";